module.exports = __webpack_public_path__ + "img/Loading.4e8dd46b.gif";